module.exports = __webpack_public_path__ + "img/add-a-photo.1941344.svg";